import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-5b70230a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "list-share-users-index" }
const _hoisted_2 = {
  key: 0,
  class: "list-share-users-index__wrapper"
}
const _hoisted_3 = { class: "list-share-users-index__item-content" }
const _hoisted_4 = { class: "list-share-users-index__title" }
const _hoisted_5 = {
  key: 0,
  class: "list-share-users-index__subtitle"
}
const _hoisted_6 = ["textContent"]
const _hoisted_7 = { class: "list-share-users-index__item-actions" }
const _hoisted_8 = ["textContent"]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = {
  key: 1,
  class: "list-share-users-index__empty"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("picture", { class: "list-share-users-index__empty-illustration" }, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "Users illustration",
    src: "/img/icons/lists-users-empty-state.svg"
  })
], -1))
const _hoisted_12 = { class: "list-share-users-index__empty-title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PxAvatar = _resolveComponent("PxAvatar")!
  const _component_ElTag = _resolveComponent("ElTag")!
  const _component_PxIcon = _resolveComponent("PxIcon")!
  const _component_ElTooltip = _resolveComponent("ElTooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.users.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.users, (user, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "list-share-users-index__item"
            }, [
              _createVNode(_component_PxAvatar, {
                name: user.name,
                photo: user.photo,
                size: 32,
                class: "list-share-users-index__item-photo",
                styling: "neutral",
                type: "round"
              }, null, 8, ["name", "photo"]),
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("h3", _hoisted_4, _toDisplayString(user.name), 1),
                (user.email)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(user.email), 1))
                  : _createCommentVNode("", true)
              ]),
              (!user.user_profile)
                ? (_openBlock(), _createBlock(_component_ElTag, {
                    key: 0,
                    class: "list-share-users-index__tag",
                    effect: "light",
                    size: "small",
                    textContent: _toDisplayString(_ctx.$t('common.guest'))
                  }, null, 8, ["textContent"]))
                : _createCommentVNode("", true),
              (!user.user_profile)
                ? (_openBlock(), _createBlock(_component_ElTooltip, {
                    key: 1,
                    enterable: false,
                    placement: "top",
                    "popper-class": "list-share-users-index__tooltip list-share-users-index__tooltip--spacious el-abaca-tooltip"
                  }, {
                    content: _withCtx(() => [
                      _createElementVNode("div", {
                        textContent: _toDisplayString(_ctx.$t('companyLists.list.shareModal.tip'))
                      }, null, 8, _hoisted_6)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_PxIcon, {
                        size: 17,
                        class: "list-share-users-index__tip",
                        name: "question"
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_7, [
                (_ctx.$screen.mdUp)
                  ? (_openBlock(), _createBlock(_component_ElTooltip, {
                      key: 0,
                      ref_for: true,
                      ref: "unshare",
                      disabled: !user.user_profile,
                      enterable: false,
                      placement: "top",
                      "popper-class": "list-share-users-index__tooltip el-abaca-tooltip"
                    }, {
                      content: _withCtx(() => [
                        _createElementVNode("div", {
                          textContent: _toDisplayString(_ctx.$t('companyLists.list.shareModal.unshare'))
                        }, null, 8, _hoisted_8)
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("div", {
                          class: _normalizeClass([{ 'is-disabled': !user.user_profile }, "list-share-users-index__unshare-cta"]),
                          onClick: _withModifiers(($event: any) => (_ctx.unshareClickHandler(user.user_profile)), ["stop"])
                        }, [
                          _createVNode(_component_PxIcon, {
                            size: 14,
                            name: "trash--red"
                          }),
                          _createVNode(_component_PxIcon, {
                            size: 14,
                            class: "px-icon--hover",
                            name: "trash"
                          })
                        ], 10, _hoisted_9)
                      ]),
                      _: 2
                    }, 1032, ["disabled"]))
                  : _createCommentVNode("", true)
              ])
            ]))
          }), 128))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.$t("companyLists.list.shareModal.empty")), 1)
        ]))
  ]))
}